
export const environment: {[key: string]: any} = {
  heartbeatConfig: {
    ping: 5 * 60,
    reconnections: 20
  },
  production: true,
  sentryConfig: env.SENTRY_CONFIG,
}
